/** v396 — pure simulation math for the role × group margin matrix. */

const tot = (hours, sell, cost, costedSell) => {
  const margin = cost == null ? null : sell - cost;
  return {
    hours, sell_aud: sell, costed_sell_aud: costedSell == null ? sell : costedSell, cost_aud: cost, margin_aud: margin,
    margin_pct: margin == null || sell <= 0 ? null : (margin / sell) * 100,
    partial: costedSell != null && cost != null && Math.abs(costedSell - sell) > 0.005,
  };
};

/** Recompute every cell/total for the given what-if sell (native) and cost (A$) rates. */
export function simulateMatrix(data, sellRates, costRates) {
  const cells = data.cells.map((c) => {
    const base = data.role_totals[c.role] || {};
    const origSell = base.sell_rate_native || 0;
    const newSell = sellRates[c.role] ?? origSell;
    const factor = origSell > 0 ? newSell / origSell : 1;
    const cr = costRates[c.role];
    const cost = cr == null || cr === '' ? null : c.hours * Number(cr);
    return { group: c.group, role: c.role, ...tot(c.hours, c.sell_aud * factor, cost) };
  });
  const agg = (keyFn, keys) => {
    const out = {};
    keys.forEach((k) => {
      const mine = cells.filter((c) => keyFn(c) === k);
      let h = 0, s = 0, cs = 0, cc = 0, costed = false;
      mine.forEach((c) => { h += c.hours; s += c.sell_aud; if (c.cost_aud != null) { costed = true; cc += c.cost_aud; cs += c.sell_aud; } });
      out[k] = tot(h, s, costed ? cc : null, costed ? cs : null);
    });
    return out;
  };
  const group_totals = agg((c) => c.group, data.groups);
  const role_totals = agg((c) => c.role, data.roles);
  let h = 0, s = 0, cs = 0, cc = 0, costed = false;
  cells.forEach((c) => { h += c.hours; s += c.sell_aud; if (c.cost_aud != null) { costed = true; cc += c.cost_aud; cs += c.sell_aud; } });
  return { cells, group_totals, role_totals, overall: tot(h, s, costed ? cc : null, costed ? cs : null) };
}

export const pct = (v) => (v == null ? '—' : `${v.toFixed(1)}%`);
export const aud = (v) => (v == null ? '—' : `A$${Math.round(v).toLocaleString()}`);
export const delta = (a, b) => (a == null || b == null ? null : a - b);
export const marginTone = (v, min) => {
  if (v == null) return 'text-slate-400';
  if (v < 0 || (min != null && v < min)) return 'text-rose-600';
  if (v < 20) return 'text-amber-600';
  return 'text-emerald-700';
};
export const cellBg = (v, min) => {
  if (v == null) return 'bg-slate-50';
  if (v < 0 || (min != null && v < min)) return 'bg-rose-50';
  if (v < 20) return 'bg-amber-50';
  return 'bg-emerald-50';
};
